<template>
  <main>
    <div class="student">
      <div class="row">
        <div class="col-md-12">
          <TopTemplate>
            <template v-slot:left-element>
              <h3>{{ $t("title.parents") }} ({{ total }})</h3>
            </template>
          </TopTemplate>
          <div class="search-date-wrapper search-filter-wrapper" :class="{borderNan: !showFil}">
            <div class="col-md-11 search searchStudent">
              <input v-model="params.q" type="text" placeholder="Recherche" name="search" @input="searshParent()" />
              <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />

            </div>
            <div class="date-wrapper filter-wrapper" @click="showFilter()">
              <span>{{ $t("barFiltre.filtre") }}</span>
            </div>
          </div>
          <div v-if="showFil" class="row container-select container-filter filter">
            <div v-if="params.selected_school_id ||
              params.selected_status_id ||
              params.selected_system_id
              " class="col-md-12">
              <div class="reset_student" @click="resetFilter()">
                <i class="icon-reset" />
                {{ $t("barFiltre.renitialiser") }}
              </div>
            </div>
            <div class="select-wrapper" v-if="!exist" :class="grid">
              <span class="title-select">{{ $t("barFiltre.school") }} </span>
              <v-select v-model="params.selected_school_id" :options="schools" :searchable="true" label="name"
                :reduce="(option) => option.id" @update:modelValue="ChangeSchool()">
                <template #no-options="{  }">
                  {{ $t("info.noResult") }}
                </template>
              </v-select>
            </div>
            <div class="select-wrapper" :class="grid">
              <span class="title-select">{{ $t("barFiltre.statut") }}</span>
              <v-select v-model="params.selected_status_id" :options="status" :searchable="true" label="name"
                :reduce="(option) => option.id" @update:modelValue="ChangeStatus()">
                <template #no-options="{  }">
                  {{ $t("common.emptySystem") }}
                </template>
              </v-select>
            </div>
            <div class="select-wrapper" :class="grid">
              <span class="title-select">{{ $t("barFiltre.system") }}</span>
              <v-select v-model="params.selected_system_id" :options="system" :searchable="true" label="name"
                :reduce="(option) => option.name" @update:modelValue="ChangeSystem()">
                <template #no-options="{  }">
                  {{ $t("common.emptySystem") }}
                </template>
              </v-select>
            </div>
            <div class="select-wrapper" :class="grid">
              <span class="title-select">{{ $t("barFiltre.version") }}</span>
              <v-select v-model="params.app_version" :options="versions" :searchable="true" label="name"
                :reduce="(option) => option" @update:modelValue="ChangeVersion($event)">
                <template #no-options="{}">
                  {{ $t("common.emptySystem") }}
                </template>
              </v-select>
            </div>
          </div>
        </div>
      </div>
      <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="container-fluid empty-message">
        <div class="col-md-12">
          <div v-if="levels.length === 0 && !params.hasfilter && !loading" class="card mt-4">
            <div class="col-12 empty-result text-center pt-3">
              <p>{{ $t("common.emptysearshParent") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="!loading && levels.length > 0">
        <div class="col-md-12 classes-liste parent-list">
          <div class="table">
            <div class>
              <div class="row">
                <div class="col-md-12">
                  <div class="table__wrapper table-responsive-vertical table-responsive">
                    <table class="table__classes">
                      <thead>
                        <tr>
                          <th class="col-md-2">{{ $t("parent.tab.nom") }}</th>
                          <th class="col-md-1 ">{{ $t("parent.tab.type") }}</th>
                          <th class="col-md-2 mail-td">{{ $t("parent.tab.email") }}</th>
                          <th class="col-md-2 phon-td">{{ $t("parent.tab.phone") }}</th>
                          <th class="col-md-1">
                            {{ $t("parent.tab.system") }}
                          </th>
                          <th class="col-md-1">
                            {{ $t("parent.tab.version") }}
                          </th>
                          <th class="col-md-2">
                            {{ $t("parent.tab.status") }}
                          </th>
                          <th class="col-md-2">
                            {{ $t("common.actions") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(level, index) in levels" :key="index">
                          <td colspan="9" class="td_content_all">
                            <table class="table__classes" width="100%">
                              <thead>
                                <tr class="item_level">
                                  <th
                                    class="col-md-2 pointer"
                                    @click="level.isActive = !level.isActive"
                                    :class="[!level.children.length ? 'space-right' : '']"
                                    v-if="level.last_name || level.first_name"
                                  >
                                    <i
                                      v-if="level.children.length"
                                      class="arrow down arrow-collapse"
                                      :class="[level.children.length ? (level.isActive ? 'toRotate' : '') : 'space-right']"
                                    />
                                    <span class="lastName_propre"> {{ level.last_name }} </span>&nbsp;<span class="name_propre"> {{ level.first_name }} </span>
                                  </th>
                                  <th class="col-md-2 pointer" @click="level.isActive = !level.isActive" :class="[!level.children.length ? 'space-right' : '']" v-else>
                                    <i
                                      v-if="level.children.length"
                                      class="arrow down arrow-collapse"
                                      :class="[level.children.length ? (level.isActive ? 'toRotate' : '') : 'space-right']"
                                    />
                                    __
                                  </th>
                                  <th class="col-md-1">
                                    <div style="height: 16px">
                                      <p v-if="level.is_tuteur === 0 && level.gender === 0"><span>P</span><span style="text-transform: lowercase">ère</span></p>
                                      <p v-else-if="level.is_tuteur === 0 && level.gender === 1"><span>M</span><span style="text-transform: lowercase">ère</span></p>
                                      <p v-else><span>T</span><span style="text-transform: lowercase">uteur</span></p>
                                    </div>
                                  </th>

                                  <th class="col-md-2 mail-td">
                                    <span v-if="level.email" style="text-transform: lowercase">
                                      {{ level.email }}</span>
                                    <span v-else>__</span>
                                  </th>

                                  <th class="col-md-2 phon-td">{{ formatPhone(level.phone, true) }}</th>

                                  <th class="col-md-1">
                                    <p v-if="level.app_system">
                                      <span style="text-transform: lowercase">
                                        {{ level.app_system }}
                                      </span>
                                    </p>
                                    <p v-else style="opacity: 0.7">__</p>
                                  </th>

                                  <th class="col-md-1">
                                    <p v-if="level.app_version">
                                      {{ level.app_version }}
                                    </p>
                                    <p v-else style="opacity: 0.7">__</p>
                                  </th>
                                  <th class="col-md-2">
                                    <p>
                                      <span :class="statusClass(level)"> {{level.parent_account_status === 1 ?  $t("common.blocked") : statusText(level)  }}</span>
                                    </p>
                                  </th>
                                  <th class="col-md-2">
                                    <div class="d-flex justify-content-start align-items-start">
                                      <!-- <i v-if="statusSchoolYear" class="icon-edit-02" @click="findType(level), pushData(level), (level.showModal = true), hideError()">
                                        <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                                      </i> -->
                                      <EditParent v-if="statusSchoolYear" :parent="level" @handleData="LevelsList()" :icon="true" />
                                      <router-link
                                        class="mr-2 ml-2"
                                        :to="{
                                          name: 'show-parent',
                                          params: {id: level.id},
                                        }"
                                      >
                                        <i class="icon-eyes">
                                          <span class="tooltiptext">{{ $t("common.details") }}</span>
                                        </i>
                                      </router-link>
                                      <i v-if="statusSchoolYear" class="icon-trash" @click.prevent="deleteParent(level)" style="margin-right: 8px; margin-left: 8px">
                                        <span class="tooltiptext">{{ $t("button.tooltip.delete") }}</span>
                                      </i>
                                      <i v-if="statusSchoolYear" class="icon-forbiden" @click.prevent="blockParent(level)" style="margin-right: 0">
                                        <span class="tooltiptext">{{ $t("button.tooltip.blocage") }}</span>
                                      </i>
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody v-if="level.children.length && level.isActive" class="body-child">
                                <td colspan="9">
                                  <table class="item_table_classes">
                                    <thead class="head-student">
                                      <tr style="border-bottom: 2px solid #e0e7ed">
                                        <th class="td-width" width="12%">
                                          Nom & Prénom
                                        </th>
                                        <th v-if="!exist" class="td-width" width="12%">
                                          Ècoles
                                        </th>
                                        <th v-if="exist" class="td-width"></th>
                                        <th class="td-width" width="12%">
                                          Niveau
                                        </th>
                                        <th class="td-width">Classe</th>
                                        <th class="td-width"></th>
                                        <th class="td-width"></th>
                                        <th class="td-width"></th>
                                        <th class="action td-width"></th>
                                      </tr>
                                    </thead>
                                    <tr v-for="child in level.children" :key="child.id"
                                      class="item_class item-child name_propre">
                                      <td class="td-width">
                                        <span class="lastName_propre">{{ child.last_name }} </span>&nbsp;
                                        <span class="name_propre">{{ child.first_name }}</span>
                                      </td>
                                      <td v-if="!exist" class="td-width">
                                        <div>{{ child.school.name }}</div>
                                      </td>
                                      <td v-if="exist" class="td-width"></td>
                                      <td class="td-width">
                                        <span v-if="child.class_types">{{ child.class_types.name }}</span>
                                        <span v-else>__</span>
                                      </td>
                                      <td class="td-width">
                                        <span v-if="child.class">{{ child.class.name }}</span>
                                        <span v-else>__</span>
                                      </td>
                                      <td class="
                                        td-width
                                        text-end
                                        d-flex
                                        justify-content-end
                                      " style="padding: 8px 0">
                                        <div class="dropdown-support">
                                          <i class="icon-dots" @click="displayBloc(child.id, index)" />
                                          <div class="dropdown-child" ref="child" :id="`div${child.id}${index}`" :class="{'permission-height': !statusSchoolYear}">
                                            <div class="item">
                                              <router-link :to="{
                                                  name: 'DetailStudent',
                                                params: { id: child.id },
                                              }" style="color: #111111">
                                                Détails
                                              </router-link>
                                              <router-link :to="{
                                                  name: 'DetailStudent',
                                                params: { id: child.id },
                                              }">
                                                <i class="icon-eyes" />
                                              </router-link>
                                            </div>
                                            <div v-if="statusSchoolYear" class="item">
                                              <router-link :to="{
                                                  name: 'EditStudent',
                                                params: { id: child.id },
                                              }" style="color: #111111">
                                                Modifier
                                              </router-link>
                                              <router-link :to="{
                                                  name: 'EditStudent',
                                                params: { id: child.id },
                                              }" style="color: #111111">
                                                <i class="icon-edit-02" />
                                              </router-link>
                                            </div>
                                            <div v-if="statusSchoolYear" class="item">
                                              <div @click.prevent="
                                                deleteStudent(child, level)
                                                ">
                                                Supprimer
                                              </div>
                                              <i class="icon-trash" @click.prevent="
                                                deleteStudent(child, level)
                                                " />
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="table__wrapper__pagination-wrapper">
                      <div class="pagination text-right">
                        <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getResults" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import StudentService from "../../services/student.service";
import pagination from "../../components/navigation/Pagination";
import EditParent from "../../components/parents/EditParent";
import vSelect from "vue-select";
import moment from "moment";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import _ from "lodash";
import ParentService from "../../services/parent.service";
import SchoolService from "../../services/school.service";
import {parsePhoneNumberFromString} from "libphonenumber-js";
import useValidate from "@vuelidate/core";
import {required, maxLength, helpers, email, minLength, sameAs} from "@vuelidate/validators";
import {mapActions, mapGetters} from "vuex";
export default {
  name: "StudentsList",
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
    Datepicker,
    EditParent,
  },
  setup() {
    const format = (due_date) => {
      const day = due_date.getDate();
      const month = due_date.getMonth() + 1;
      const year = due_date.getFullYear();
      if (day <= 9) {
        return `0${day}/0${month}/${year}`;
      }
      if (day > 9) {
        return `${day}/${month}/${year}`;
      }
      if (month <= 9) {
        return `0${day}/0${month}/${year}`;
      } else {
        return `${day}/${month}/${year}`;
      }
    };

    return {
      format,
    };
  },
  data() {
    return {
      v$: useValidate(),
      loading: false,
      showModal: false,
      pagination: {},
      total: 0,
      last_page: null,
      classes: [],
      levels: [],
      levelT: [],
      emptyTable: false,
      loaderPere: false,
      showerremailmere: false,
      versions: [],
      parent: {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        function: null,
        gender: null,
        lieu_travail: null,
        relation_eleve: null,
        ville: null,
        pays: null,
        code_postale: null,
        addresse: null,
        id: null,
        password: null,
        confirmPassword: null,
        has_payment: false,
      },
      phoneExists: false,
      emaiExists: false,
      datea: null,
      readInput: true,
      showFil: false,
      numPere: false,
      status: [
        {
          id: 1,
          name: "Enregistré",
        },
        {
          id: 2,
          name: "Non enregistré",
        },
      ],
      system: [
        {
          id: 1,
          name: "Android",
        },
        {
          id: 2,
          name: "iOS",
        },
      ],

      params: {
        q: "",
        limit: 15,
        page: 1,
        sort: "",
        order: false,
        class_type_id: [],
        class_school_id: [],
        school_id: "",
        birthday: null,
        datede: null,
        selected_status_id: null,
        selected_system_id: null,
        selected_school_id: null,
        app_version: null,
        hasfilter: false,
      },
      level: {
        showModal: false,
      },

      selectedLevel: null,
      selectedClass: null,
      students: [],
      selected: [],
      schools: [],
      exist: "",
      grid: "",
      type: "",
      existPay: false,
      passageYears: null,
    };
  },
  watch: {
    getPassageYears(val) {
      if (val.id) {
        this.params.q = "";
        this.params.selected_status_id = null;
        this.params.selected_system_id = null;
        this.params.app_version = null;
        this.passageYears = val.id;
        this.LevelsList();
      }
    },
  },
  validations() {
    return {
      parent: {
        first_name: {
          required: helpers.withMessage(this.$t("validation.required"), required),
          maxLength: maxLength(100),
        },
        last_name: {
          required: helpers.withMessage(this.$t("validation.required"), required),
          maxLength: maxLength(100),
        },
        email: {
          email: helpers.withMessage(this.$t("validation.email"), email),
          maxLength: maxLength(100),
        },
        password: {minLength: minLength(8)},
        confirmPassword: {sameAsPassword: sameAs(this.parent.password)},
        phone: {
          required: helpers.withMessage(this.$t("validation.required"), required),
          maxLength: helpers.withMessage(this.$t("validation.phoneMaxLength"), minLength(8)),
        },
      },
    };
  },
  computed: {
    ...mapGetters(["getPassageYears"]),
    statusClass() {
      return (parent) => {
        if (parent.parent_account_status == 1) {
          return "blocked_status";
        }
        return parent.status === 1 ? "active_status" : "noActive_status";
      };
    },
    statusText() {
      return (parent) => {
        return parent.status === 1 ? this.$t("common.save") : this.$t("common.noSave");
      };
    },
    statusSchoolYear() {
      return this.getPassageYears.status;
    },
    selectAll: {
      get: function () {
        return this.students ? this.selected.length == this.students.length : false;
      },
      set: function (value) {
        let selected = [];

        if (value) {
          this.students.forEach(function (student) {
            selected.push(student.id);
          });
        }

        this.selected = selected;
      },
    },
    UserRole() {
      return JSON.parse(localStorage.getItem("user"));
    },
  },

  mounted() {
    this.moduleUser();
    if (this.getPassageYears.id) {
      this.passageYears = this.getPassageYears.id;
      this.LevelsList();
    }
    this.checkClass();
    this.params.school_id = this.$store.state.auth.user.school_id;
    this.UserRole.role.map((role) => {
      if (role.name === "admin") {
        this.getSchool();
      }
    });

    this.getVersion();
    this.emptyTable = true;
  },
  methods: {
    ...mapActions(['blocageParent']),
    blockParent(parent) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: parent.parent_account_status == 0 || parent.parent_account_status == null ? this.$t("common.confirmBlockedParent") : this.$t('common.confirmdeblockedParent'),
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          this.selected = [];
          if (result.isConfirmed) {
            const params = {
              id: parent.id,
              payload: {
                status: parent.parent_account_status == 0 ||parent.parent_account_status == null  ? 1 : 0,
              },
            };
            this.blocageParent(params).then(
              () => {
                const status = parent.parent_account_status == 0 ||parent.parent_account_status == null  ? 1 : 0
                swalWithBootstrapButtons.fire(status == 0 ?this.$t("common.parentDeblocked") : this.$t("common.parentBlocked")  , "", "success");
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },
    checkIfElementPayIsEleves() {
      const userModuleArray = Object.values(this.$store.state.auth.user.modules);
      return userModuleArray.some((element) => element.name === this.$t("modules.payment"));
    },
    moduleUser() {
      this.existPay = this.checkIfElementPayIsEleves();
    },
    hideError() {
      this.phoneExists = false;
      this.emaiExists = false;
    },

    formatPhone(value, sep) {
      if (!value) return sep ? "__" : "";
      const phoneNumber = parsePhoneNumberFromString(value, "TN");
      return phoneNumber ? phoneNumber.formatNational() : "__";
    },
    displayBloc(id, index) {
      var element = document.getElementById(`div${id}${index}`);
      var y = document.querySelectorAll(".dropdown-child");
      y.forEach((el) => {
        if (el.classList.contains("display-element")) {
          if (el != element) {
            el.classList.remove("display-element");
          }
        }
      });
      element.classList.toggle("display-element");
    },
    findType(element) {
      if (element.is_tuteur === 0) {
        if (element.gender === 0) {
          this.type = "Père";
        } else {
          this.type = "Mère";
        }
      } else {
        this.type = "Tuteur";
      }
    },
    getSchool() {
      SchoolService.getAll({
        params: {},
      }).then(
        (response) => {
          this.schools = response.data.data;
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    checkClass() {
      this.UserRole.role.map((role) => {
        if (role.name === "admin_school" || role.name === "parent" || role.name === "teacher") {
          this.exist = true;
          this.grid = "col-md-4";
        } else {
          this.exist = false;
          this.grid = "col-md-3";
        }
      });
    },
    pushData(level) {
      (this.parent.first_name = level.first_name),
        (this.parent.password = null),
        (this.parent.confirmPassword = null),
        (this.parent.last_name = level.last_name),
        (this.parent.email = level.email),
        (this.parent.phone = this.formatPhone(level.phone, false)),
        (this.parent.function = level.function),
        (this.parent.gender = level.gender),
        (this.parent.lieu_travail = level.lieu_travail),
        (this.parent.ville = level.ville),
        (this.parent.pays = level.pays),
        (this.parent.code_postale = level.code_postale),
        (this.parent.addresse = level.addresse);
      this.parent.has_payment = level.has_payment;

      this.parent.id = level.id;
    },

    updateParent(level) {
      this.v$.$validate();
      if (!this.v$.$error) {
        ParentService.update(this.parent.id, this.parent)
          .then(() => {
            this.is_created = true;
            this.loading = false;
            level.showModal = false;
            this.LevelsList();
          })
          .catch((error) => {
            this.is_created = false;
            this.loading = false;
            this.phoneExists = error.response.data.errors.phone;
            this.emaiExists = error.response.data.errors.email;
          });
      }
    },
    LevelsList() {
      this.loading = true;
      ParentService.getAll({
        params: {
          order: this.params.order,
          limit: this.params.limit,
          page: this.params.page,
          q: this.params.q,
          sort: this.params.sort,
          status: this.params.selected_status_id,
          app_system: this.params.selected_system_id,
          school_id: this.params.school_id,
          school: this.params.selected_school_id,
          school_year: this.passageYears,
        },
      })
        .then((response) => {
          this.levels = response.data.data;
          this.levels = this.levels.map((level, index) => {
            if (index === 0) {
              return {...level, isActive: true};
            } else {
              return {...level, isActive: false};
            }
          });
          if (this.levels.length > 0) {
            this.emptyTable = false;
          }
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
          this.params.hasfilter = false;
        });
    },
    getVersion() {
      ParentService.getVersion().then((response) => {
        if (response.data.length > 0) {
          this.versions = response.data.map((item, index) => ({
            id: index,
            name: item.app_version,
          }));
        }
      });
    },
    getResults(page = null) {
      this.selected = [];
      this.params.page = !page ? this.params.page : page;
      this.loading = true;
      ParentService.getAll({
        params: {
          order: this.params.order,
          limit: this.params.limit,
          page: this.params.page,
          q: this.params.q,
          sort: this.params.sort,
          status: this.params.selected_status_id,
          app_system: this.params.selected_system_id,
          school_id: this.params.school_id,
          app_version: this.params.app_version,
          school_year: this.passageYears,
        },
      }).then(
        (response) => {
          this.levels = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;

          this.loading = false;
        },
        (error) => {
          //
          this.loading = false;
        }
      );
    },

    resetFilter() {
      this.params.q = "";
      this.params.selected_status_id = null;
      this.params.selected_system_id = null;
      this.params.app_version = null;
      this.getResults();
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
    },
    showFilter() {
      this.showFil = !this.showFil;
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    deleteParent(level) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      const index = this.levels.findIndex((items) => items.id === level.id);
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteParent") + " " + level.last_name + " " + level.first_name + "?",
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            ParentService.delete(level.id).then(
              () => {
                swalWithBootstrapButtons.fire(this.$t("common.parentDeleted"), "", "success");
                this.params.page = 1;
                this.getResults();
              },
              (error) => {
                swalWithBootstrapButtons.fire(this.$t("common.parentNotDeleted"), "", "success");
                this.loading = false;
              }
            );
          }
        });
    },
    deleteStudent(child, element) {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      const index = element.children.findIndex((items) => items.id === child.id);
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteStudent") + " " + child.last_name + " " + child.first_name + "?",
          icon: "warning",
          showCloseButton: true,
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.studentDeleted"), "", "success");
            element.children.splice(index, 1);
            StudentService.delete(child.id);
          }
        });
    },
    deleteSelected() {
      const Swal = require("sweetalert2");
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-confirm  btn-primary",
          cancelButton: "btn  btn-cancel  btn-outline-primary",
        },
        buttonsStyling: false,
        showCloseButton: true,
      });
      swalWithBootstrapButtons
        .fire({
          title: this.$t("common.confirmDeleteSelectedStudent"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: this.$t("common.deletIT"),
          cancelButtonText: this.$t("common.noCancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.isConfirmed) {
            swalWithBootstrapButtons.fire(this.$t("common.studentSelectedDeleted"), "", "success");
            StudentService.deleteAll({
              params: {
                studentsId: this.selected,
              },
            }).then(
              () => {
                this.getResults();
              },
              (error) => {
                this.loading = false;
              }
            );
          }
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    ChangeLevel(e) {
      if (e != null) {
        this.params.class_type_id = [];
        this.params.class_type_id.push(e);
      } else {
        this.params.class_type_id = [];
      }
      this.getResults();
    },
    ChangeStatus() {
      this.getResults();
      this.params.hasfilter = true;
    },
    ChangeSchool() {
      this.getResults();
      this.params.hasfilter = true;
    },
    ChangeSystem() {
      this.getResults();
      this.params.hasfilter = true;
    },
    ChangeVersion(e) {
      if (e != null) {
        this.params.app_version = {};
        this.params.app_version = e.name;
      } else {
        this.params.app_version = null;
      }
      this.getResults();
    },
    handleInput() {
      this.readInput = false;
      if (this.params.datede != null) {
        this.params.datede = this.dateTime(this.params.datede);
      }
      this.getResults();
    },

    searshParent: _.debounce(function () {
      this.params.page = 1;
      if (this.params.q.toString().length > 1 || !this.params.q.toString().length) {
        this.params.hasfilter = true;
        this.LevelsList();
      }
    }, 200),
  },
};
</script>
<style>
.invalid-champ {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.custom-btn {
  margin-left: auto;
  margin-top: 17px;
}

th.col-md-2.mail-td {
  max-width: 180px !important;
  word-wrap: break-word !important;
  min-width: 180px;
}

th.col-md-2.pointer {
  max-width: 120px !important;
  word-wrap: break-word !important;
  min-width: 120px;
}

.paiement-content label.label-name {
  width: max-content;
}

.paiement-content {
  display: flex;
}

.slider {
  position: absolute;
  cursor: pointer;
  left: 21%;
  right: 10%;
  top: 16%;
  bottom: 26%;
  background-color: #e8e6eb;
  transition: 0.4s;
}

input:checked + .slider {
  background: #34b9bb;
}

input:checked + .slider:before {
  position: absolute;
  content: "";
  left: 36.44%;
  right: 0px;
  top: 0px;
  bottom: 0px;
  background-color: white;
  transition: 0.4s;
  margin: 2px;
  margin-right: 7px;
}

.slider:before {
  position: absolute;
  content: "";
  left: 0;
  right: 49.44%;
  top: 0;
  bottom: 0;
  background-color: #a098ae;
  transition: 0.4s;
  margin: 2px;
  margin-left: 2px;
}
</style>
